import { IoMdPlay } from "react-icons/io";
import "./ShapeWear.css";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../constant.js";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function ShapeWear() {
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchShapewearImage = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/homepage/images/get-shapewear`
        );
        setImageUrl(response.data);
      } catch (error) {
        console.error("Error fetching shapewear image:", error);
      }
    };

    fetchShapewearImage();
  }, []);
  const handleButtonClick = (redirectUrl) => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/shop");
    }
  };
  return (
    <div className="shapewear">
      {imageUrl ? (
        <div className="image-container">
          <img
            src={imageUrl.imageUrl}
            alt="Shapwear"
            text="Third slide"
            className="d-block w-100"
          />

          <button
            className="shapeware-explore-btn"
            onClick={() => handleButtonClick(imageUrl.redirectUrl)}
          >
            <span>Explore Now</span>
            <IoMdPlay className="shapeware-explore-arrow" />
          </button>
        </div>
      ) : (
        <p>Loading image...</p>
      )}
    </div>
  );
}

export default ShapeWear;
